export const enum DocumentError {
	FileUnavailable = 1,
	LibraryUnavailable = 2
}
